import { combineReducers } from 'redux';

import { createResourceModuleReducerMap, mlRel } from 'medialoopster/rest';

import { AppConnectorsRootState } from './types';

export default combineReducers<AppConnectorsRootState>(
  createResourceModuleReducerMap('appconnector', mlRel('appconnectors')),
);
